import { useEffect } from 'react';
import {
  Button,
  Flex,
  Heading,
  Link,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Spacer,
  useDisclosure,
} from '@chakra-ui/react';
import i18next from 'i18next';
import type { NextPage } from 'next';

import CourseStructure from '@/components/course-structure/course-structure';
import { colors, spacing } from '@/styles/ui.theme';

import Illustration from '../assets/svg/software-engineer.svg';

const HomePage: NextPage = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  const onboardingKey = 'dona-neia-alpha-onboarding-seen';

  useEffect(() => {
    if (!localStorage.getItem(onboardingKey)) {
      onOpen();
    }
  }, []);

  const onModalClose = (): void => {
    localStorage.setItem(onboardingKey, 'true');
    onClose();
  };

  return (
    <Flex w='100%' direction='column' alignItems='center' justifyContent='flex-start'>
      <Heading>{i18next.t('homePage.title')}</Heading>
      <Heading pt={spacing.lg} size='md'>
        {i18next.t('homePage.subtitle')}
      </Heading>
      <Flex pt={spacing.lg} w='95%' h='auto' alignItems='center' justifyContent='center'>
        <Illustration />
      </Flex>

      <Heading py={spacing.lg} size='md'>
        {i18next.t('homePage.courseOrganizationDescription')}
      </Heading>
      <CourseStructure width='720px' height='720px' />

      <Heading pt={spacing.lg} size='sm'>
        {i18next.t('homePage.footer')}
      </Heading>

      <Modal data-testid='alpha-modal-testid' isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Alpha Testing</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            Seja bem vindo ao nosso Alpha Testing do novo CMS da Faculdade Descomplica!
            <Spacer pb={spacing.sm} />A idéia deste teste interno é refinar o produto final,
            descobrindo bugs, problemas e oportunidades de melhorias, antes que seja liberado para
            todos os usuários. Estamos coletando todos os feedbacks através
            <Link
              href='https://descomplica.slack.com/archives/CJTLDGJCX/p1661255768724149'
              color={colors.descomplica.green.dark}
              ml={spacing.xxs}
            >
              desta thread no Slack
            </Link>
            .
            <Spacer pb={spacing.sm} />
            Nos vemos lá 😉
          </ModalBody>

          <ModalFooter>
            <Button colorScheme='blue' mr={3} onClick={onModalClose}>
              Fechar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Flex>
  );
};

export default HomePage;
